import {
	CloseOutlined,
	InfoCircleOutlined,
	PushpinOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, List, Select, Tooltip, Slider } from 'antd';
import getSymbolFromCurrency from 'currency-symbol-map';
import _, { get } from 'lodash';
import { Component, createRef } from 'react';
import { withApollo } from 'react-apollo';
import ReactGA from 'react-ga';
import fileIcon from 'src/_shared/assets/erin_lightgray.png';
import WebIcon from 'src/_shared/components/WebIconComponent.jsx';
import OnDeckReferralModal from 'src/_shared/components/on-deck/on-deck-modal/OnDeckModalComponent.jsx';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import {
	getDaysBetweenDates,
	getEnvironment,
	getISODateRangeUTC,
	getLocation,
	getSetErrorImageURL,
	ml,
	parse,
	searchOpenSearchNetwork,
	subtractDays,
} from 'src/_shared/services/utils.js';
import { COLORS } from 'src/_shared/styles/colors';
import {
	QueryCompensationGradesByCompanyId,
	QueryHiringManagersByCompanyId,
} from 'src/graphql/custom/jobs';
import { AdvanceFilters } from './AdvanceFiltersComponent.jsx';
import BrowseJobModal from './BrowseJobsModalComponent.jsx';
import { JobCard } from './jobCard/index.js';

const filterOpenKey = 'open';

const { Option } = Select;
class BrowseJobsComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			someJobHasBonus: true,
			company: get(props, 'currentUser.company'),
			theme: parse(get(props, 'currentUser.company.theme', '{}')),
			visible: false,
			filteredCompanies: props?.currentUser?.companyId
				? [props?.currentUser?.companyId]
				: [],
			noBonusValue: false,
			filteredDate: undefined,
			filteredDepartments: [],
			searchedJobs: [],
			filteredAvailables: [],
			filteredBonuses: [],
			filteredJobs: get(props, 'jobs', []),
			filteredSalary: undefined,
			allJobs: get(props, 'jobs', []),
			searchQuery: get(props, 'jobSearchCriteria'),
			loading: true,
			isExtendedUser: get(props, 'currentUser.role') === 'extendedUser',
			page: 0,
			errors: {},
			filterOpenStatus: filterOpenKey,
			contactsNextToken: true,
			currencyRate: 0,
			currencySymbol: '$',
			success: false,
			extendedNetworkUsers: get(
				this.props,
				'currentUser.extendedContactData',
				[]
			).map((contact) => get(contact, 'user')),
			allowSelfReferralsInternalLink: get(
				props,
				'currentUser.company.allowSelfReferralsInternalLink'
			),
			text: 'Open Jobs',
			filteredDistance: this.makeNewMenuOption(
				get(props, 'currentUser.defaultDistance', '0')
			),
			maxLoaded: 1,
			companyData: props.companyData,
			address: [
				parse(props?.currentUser?.location)?.city,
				parse(props?.currentUser?.location)?.state,
				parse(props?.currentUser?.location)?.country,
			]
				.filter(Boolean)
				.join(', '),
			city: parse(props?.currentUser?.location)?.city,
			state: parse(props?.currentUser?.location)?.state,
			country: parse(props?.currentUser?.location)?.country,
			subCompanyLabel: get(
				props,
				'currentUser.company.subCompanyLabel',
				'Company'
			)
				? get(props, 'currentUser.company.subCompanyLabel', 'Company')
				: 'Company',
			filteredSubCompanies:
				get(props, 'currentUser.company.defaultToSubcompany') &&
				get(props, 'currentUser.subCompanyId')
					? [get(props, 'currentUser.subCompanyId')]
					: [],
			filteredJobLevels: [],
			filteredCompensationGrades: [],
			filteredHiringManagers: [],
			compensationGradeOptions: [],
			hiringManagerOptions: [],
			defaultLocation: get(props, 'currentUser.defaultDistance')
				? get(props, 'currentUser.defaultDistance')
				: get(props, 'currentUser.company.defaultLocation')
					? get(props, 'currentUser.company.defaultLocation')
					: '0',
			isLocationPopoverVisible: false,
			location: parse(props?.currentUser?.location),
			lat: parse(props?.currentUser?.location)?.lat,
			lng: parse(props?.currentUser?.location)?.lng,
			referPage: get(props, 'referPage', null),
			visibleGeneral: false,
			contacts: props.contacts,
			updatedContacts: props.contacts,
			onDeckContacts: props.onDeckContacts,
			contact: props.contact,
			filteredJobsGeneral: [],
			onlyShowHot: false,
			filterTitle: 'Hide Filters',
			visibleAdvance: true,
			hideBonusFilter: get(
				props,
				'currentUser.company.hideBonusFilterOnBrowseJobs'
			),
			hideSubcompanyOnJobs: get(
				props,
				'companyData.hideSubcompanyOnJobs',
				false
			),
			errorImageURL: '',
			pageSizeHotJobs: null,
			totalResults: 0,
			totalHotJobResults: 0,
		};
		this.containerRef = createRef();
		this.intervalId = null;
		this.resizeAttempts = 0;
	}

	componentDidUpdate(prevProps) {
		const {
			contacts,
			onFetchMoreContacts,
			contactsNextToken,
			bonuses = [],
			currentUser,
		} = this.props;

		if (prevProps.contacts !== contacts) {
			if (onFetchMoreContacts) onFetchMoreContacts();

			this.setState({
				contacts,
				// Keep the copy handed to the referral modals (JobCard "Refer
				// Someone") in sync. It's seeded from props.contacts in the
				// constructor, but the contacts query resolves after mount, so
				// without this the modal dropdown stays permanently empty.
				updatedContacts: contacts,
				contactsNextToken:
					contactsNextToken === undefined ? true : contactsNextToken,
			});
		}

		if (prevProps.companyData !== this.props.companyData) {
			if (this.props.onFetchMore) this.props.onFetchMore();
			this.setState({
				companyData: this.props.companyData,
			});
		}

		if (prevProps.bonuses !== bonuses) {
			const bonusTierAmounts = bonuses
				.map((bonus) => {
					const total = bonus.tiers
						.map((tierJSON) => JSON.parse(tierJSON))
						.filter((tier) => tier.recipientType === 'employee')
						.filter((tier) => tier.userGroup === currentUser.userGroupId)
						.reduce((sum, tier) => sum + Number.parseInt(tier.amount), 0);
					return { id: bonus.id, total };
				})
				.sort((a, b) => a.total - b.total);

			const tierAmounts = bonusTierAmounts.map((item) => item.total);
			const max =
				tierAmounts.length > 0 ? Math.max(0, Math.max(...tierAmounts)) : 0;

			if (max === 0 && !this.state.noBonusValue) {
				this.setState({ noBonusValue: true });
			} else if (max > 0 && this.state.noBonusValue) {
				this.setState({ noBonusValue: false });
			}
		}
	}

	async componentWillUnmount() {
		clearInterval(this.intervalId);
		window.removeEventListener('resize', this.handleResize);
		await this.props.updateCurrentUserSearchCriteria('');
	}

	selectSearch = async (name, type = 'jobs') => {
		const { currentUser } = this.props;
		let search = parse(get(currentUser, 'search'));
		search ||= {
			recent: { jobs: [], employees: [], referrals: [] },
			saved: { jobs: [], employees: [], referrals: [] },
		};
		let recent = get(search, `recent.${type}`);
		let saved = get(search, `saved.${type}`);
		saved ||= [];
		recent ||= [];
		let matchingQuery = null;
		matchingQuery = saved.find((item) => item?.name === name);
		matchingQuery ||= recent.find((item) => item?.name === name);
		if (!matchingQuery) return;
		const formattedSearch = this.formatSearchFilters(matchingQuery);
		const { state } = formattedSearch;
		state.searchQuery = name;
		if (
			state.filteredBonuses.length > 0 ||
			state.filteredDepartments.length > 0 ||
			state.filteredSubCompanies.length > 0 ||
			state.filteredSalary ||
			state.filteredDate
		) {
			this.setState({
				filterTitle: 'Hide Filters',
				visibleAdvance: true,
			});
		} else {
			this.setState({
				filterTitle: 'Show Filters',
				visibleAdvance: false,
			});
		}

		this.setState(state);
		await this.setQueryToState(name, null, state);
	};

	formatSearchFilters = (matchingQuery, state = {}) => {
		let filters = matchingQuery?.query?.filters;
		let searchType = 'opensearch';
		if (filters?.any || filters?.all) searchType = 'swiftype';
		if (searchType === 'opensearch') {
			filters = matchingQuery?.query?.request?.filters;
			state.filteredBonuses = filters?.bonuses ?? [];
			state.filteredCompanies = filters?.companies?.[0]
				? filters.companies
				: [this.props?.currentUser?.companyId];
			const matchingDate = filters?.dateCreated;
			state.filteredDate = matchingDate
				? getDaysBetweenDates(matchingDate?.from, matchingDate?.to)
				: 0;
			state.filteredDepartments = filters?.departments ?? [];
			state.filteredDistance = filters?.distance
				? this.makeNewMenuOption(filters?.distance)
				: 'allLocations';
			state.filteredDistance = Number.parseInt(state.filteredDistance);
			state.filterOpenStatus = filters?.status ?? 'open';
			state.filteredSubCompanies = filters?.subCompanies ?? [];
			state.filteredSalary = filters?.salary ?? undefined;
		} else if (searchType === 'swiftype') {
			const matchingBonuses = filters?.any.find(
				(filter) => filter.tiered_bonus_id
			);
			state.filteredBonuses = matchingBonuses
				? matchingBonuses.tiered_bonus_id
				: [];
			const matchingCompanies = filters?.all.find(
				(filter) => filter.company_id
			);
			state.filteredCompanies = matchingCompanies
				? matchingCompanies?.company_id
				: [currentUser?.companyId];
			const matchingDate = filters?.all.find((filter) => filter.date_created);
			state.filteredDate = matchingDate
				? getDaysBetweenDates(
						matchingDate?.date_created?.from,
						matchingDate?.date_created?.to
					)
				: 0;
			const matchingDepartments = filters?.all.find(
				(filter) => filter.department_id
			);
			state.filteredDepartments = matchingDepartments
				? matchingDepartments.department_id
				: [];
			const matchingDistance = filters?.any.find((filter) => filter.location);
			state.filteredDistance = matchingDistance
				? this.makeNewMenuOption(matchingDistance?.location?.distance)
				: 'allLocations';
			const matchingStatus = filters?.all.find((filter) => filter.status);
			state.filterOpenStatus = matchingStatus ? matchingStatus.status : 'open';
			const matchingSubCompanies = filters?.all.find(
				(filter) => filter.sub_company_id
			);
			state.filteredSubCompanies = matchingSubCompanies
				? matchingSubCompanies.sub_company_id
				: [];
			const matchingSalary = filters?.any.find(
				(filter) => filter.salary_range_start
			);
			state.filteredSalary = matchingSalary
				? matchingSalary?.salary_range_start?.from
				: undefined;
		}

		const unit =
			get(this.props, 'currentUser.userGroup.measurement', 'imperial') ===
			'metric'
				? 'km'
				: 'mi';
		const request = matchingQuery;
		if (searchType === 'swiftype') {
			const newFilters = {};
			if (state?.filteredBonuses) newFilters.bonuses = state.filteredBonuses;
			if (state?.filteredCompanies)
				newFilters.companies = state.filteredCompanies;
			if (state?.filteredDate) newFilters.dateCreated = state.filteredDate;
			if (state?.filteredDepartments)
				newFilters.departments = state.filteredDepartments;
			if (state?.filteredDistance)
				newFilters.distance = state?.filteredDistance;
			if (state?.filterOpenStatus) newFilters.status = state.filterOpenStatus;
			if (state?.filteredSubCompanies)
				newFilters.subCompanies = state.filteredSubCompanies;
			if (state?.filteredSalary) newFilters.salary = state.filteredSalary;
			filters = newFilters;
			const size = request?.query?.page?.size || 300;
			request.query = {
				configMode: getEnvironment(),
				currentUser: this.props?.currentUser?.id,
				query: request?.query?.query,
				request: { ...request.query, filters, size, unit },
			};
			delete request.query.filters;
			delete request.query.request.page;
		} else {
			request.query.request.filters = filters;
		}

		return { state, request };
	};

	saveSearch = async (searchItem, operation) => {
		const { currentUser, setCurrentUser } = this.props;
		const formattedSearch = this.formatSearchFilters(searchItem);
		searchItem.query.request.filters = formattedSearch.filters;
		searchItem.query.request.currentUser = currentUser?.id;
		const res = await searchOpenSearchNetwork(searchItem, operation);
		const search = res?.search;
		if (search) {
			currentUser.search = search;
			setCurrentUser(currentUser);
		}
	};

	displaySearchFilter = (object, type = 'jobs') => {
		const { currentUser, allMultiLingualData } = this.props;
		const menuItems = [];
		const search = parse(get(currentUser, 'search'));
		if (!search) return object;
		const recent = get(search, `recent.${type}`, []);
		const saved = get(search, `saved.${type}`, []);

		if (recent.length > 0) {
			menuItems.push({
				label: (
					<div
						style={{
							fontWeight: 600,
							marginLeft: 0,
							fontSize: 14,
							color: '#262626',
						}}
					>
						{ml('Recent', currentUser, allMultiLingualData)}
					</div>
				),
				type: 'group',
				children: recent.map((item) => ({
					key: item.name,
					label: (
						<span style={{ display: 'flex', justifyContent: 'space-between' }}>
							<a
								style={{ width: '80%', paddingTop: 2 }}
								target="_blank"
								onClick={() => this.selectSearch(item.name)}
							>
								{item.name}
							</a>
							<div style={{ color: COLORS.textSecondary, paddingBottom: 3 }}>
								<a onClick={() => this.saveSearch(item, 'erin-jobs-save')}>
									<Tooltip placement="top" title="Save Search">
										<PushpinOutlined />
									</Tooltip>
								</a>
								<a
									style={{ marginLeft: 7 }}
									onClick={() =>
										this.saveSearch(item, 'erin-jobs-delete-recent')
									}
								>
									<Tooltip placement="top" title="Delete Search">
										<CloseOutlined />
									</Tooltip>
								</a>
							</div>
						</span>
					),
				})),
			});
		}

		if (recent.length > 0 && saved.length > 0) {
			menuItems.push({ type: 'divider' });
		}

		if (saved.length > 0) {
			menuItems.push({
				label: (
					<div
						style={{
							fontWeight: 600,
							marginLeft: 0,
							fontSize: 14,
							color: '#262626',
						}}
					>
						{ml('Saved', currentUser, allMultiLingualData)}
					</div>
				),
				type: 'group',
				children: saved.map((item) => ({
					key: item.name,
					label: (
						<span style={{ display: 'flex', justifyContent: 'space-between' }}>
							<a
								style={{ width: '80%', paddingTop: 2 }}
								target="_blank"
								onClick={() => this.selectSearch(item.name)}
							>
								{item.name}
							</a>
							<div style={{ color: COLORS.textSecondary, paddingBottom: 3 }}>
								<a
									onClick={() =>
										this.saveSearch(item, 'erin-jobs-delete-saved')
									}
								>
									<Tooltip placement="top" title="Delete Saved">
										<CloseOutlined />
									</Tooltip>
								</a>
							</div>
						</span>
					),
				})),
			});
		}

		const menuConfig = {
			items: menuItems,
		};

		return recent.length > 0 || saved.length > 0 ? (
			<Dropdown menu={menuConfig}>{object}</Dropdown>
		) : (
			object
		);
	};

	async componentDidMount() {
		window.addEventListener('resize', this.handleResize);
		const { currentUser } = this.props;
		const host = window.location.hostname;
		if (host === 'referrals.aus.com') {
			ReactGA.initialize('UA-128630809-2');
			ReactGA.pageview(window.location.pathname + window.location.search);
		} else if (host === 'app.erinapp.com') {
			ReactGA.initialize('UA-128630809-3');
			ReactGA.pageview(window.location.pathname + window.location.search);
		}

		const hideJobsPage = get(
			this.props,
			'currentUser.company.hideJobsPage',
			false
		);
		const displayAs = get(this.props, 'currentUser.displayAs');
		if (hideJobsPage && displayAs === 'employee') {
			window.location.href = '/dashboard';
		}

		this.fetchCompensationGrades();
		this.fetchHiringManagers();
		this.getCurrencyRate(
			this.props.currentUser && this.props.currentUser.currency
				? this.props.currentUser.currency
				: 'USD'
		);
		const distance = window.localStorage.getItem('setWithInDistance');
		if (distance === null) {
			const localLocation = window.localStorage.getItem(
				'jobLocationCoordinate'
			);
			const currentUserLocation = parse(
				get(this.props, 'currentUser.location')
			);
			if (localLocation !== undefined && localLocation !== null) {
				const userLocalLocation = parse(localLocation);
				if (
					Object.keys(userLocalLocation).length > 0 &&
					userLocalLocation.city !== undefined &&
					userLocalLocation.state
				) {
					const location = await getLocation({
						city: userLocalLocation.city,
						state: userLocalLocation.state,
					});
					this.setState(location);
				}
			} else if (
				currentUserLocation &&
				Object.keys(currentUserLocation).length > 0 &&
				currentUserLocation.city !== undefined &&
				currentUserLocation.city !== null &&
				currentUserLocation.state !== undefined &&
				currentUserLocation.state !== null
			) {
				let lat = '';
				let lng = '';
				lat = get(currentUserLocation, 'lat');
				lng = get(currentUserLocation, 'lng');
				if (lat && lng) {
					this.setState({
						city: currentUserLocation.city,
						state: currentUserLocation.state,
						lat,
						lng,
					});
				} else {
					const location = await getLocation({
						city: currentUserLocation?.city,
						state: currentUserLocation?.state,
					});
					this.setState(location);
				}
			}
		} else {
			const localLocation = parse(
				window.localStorage.getItem('jobLocationCoordinate')
			);
			const city = get(localLocation, 'city');
			const state = get(localLocation, 'state');
			this.setState({
				...localLocation,
				filteredDistance: distance
					? this.makeNewMenuOption(distance)
					: this.makeNewMenuOption(),
			});
			if (city && state) {
				this.updateFilteredJobsByLocation(
					this.makeNewMenuOption(distance),
					localLocation
				);
			}
		}

		this.intervalId = setInterval(this.handleResize, 100);
		const searchQuery = get(this.props, 'jobSearchCriteria');
		// Handle new jobs search on browse/new route
		let searchParameters;
		let jobNotificationSetting = _.get(
			this.props,
			'currentUser.jobNotificationSetting'
		);
		jobNotificationSetting &&= parse(jobNotificationSetting);
		if (window.location.pathname === '/browsejobs/new') {
			const extendedCompaniesData = get(
				currentUser,
				'extendedCompaniesData',
				[]
			);
			const extendedCompanies = extendedCompaniesData.filter(
				(company) => get(company, 'disableExtendedUserJobsView') !== true
			);
			const isExtendedUser = get(currentUser, 'role') === 'extendedUser';
			const comps =
				extendedCompanies && extendedCompanies.length > 0 && isExtendedUser
					? extendedCompanies
					: [get(this.props, 'currentUser.company')];
			const companies = comps.map((company) => get(company, 'id'));
			const departments = get(
				jobNotificationSetting,
				'departmentSelection',
				[]
			).map((item) => item.key);
			const subCompanies = get(
				jobNotificationSetting,
				'subcompanySelection',
				[]
			).map((item) => item.key);
			const salary = get(jobNotificationSetting, 'salarySelection');
			this.setState({
				filteredDate: 14,
				filteredDepartments: departments,
				filteredSubCompanies: subCompanies,
				...(salary && { filteredSalary: salary }),
				searchQuery: '',
			});
			this.setFilterTitle();
			const [from, to] = getISODateRangeUTC([
				subtractDays(14),
				new Date().toISOString(),
			]);
			searchParameters = {
				currentUser,
				filters: {
					companies,
					departments,
					status: 'open',
					subCompanies,
					dateCreated: {
						from,
						to,
					},
				},
				query: '',
				role: currentUser?.role,
				size: 300,
			};
			if (salary) searchParameters.filters.salary = salary;
		}

		await this.setQueryToState(
			get(this.state, 'searchQuery', ''),
			searchParameters
		);

		await this.setJobsGeneralQueryToState();

		const errorImageURL = await getSetErrorImageURL(
			currentUser?.company?.errorImage?.key
		);

		if (errorImageURL) {
			this.setState({ errorImageURL });
		}

		if (window.localStorage.getItem('isLocationPopoverVisible') === null) {
			if (this.state.filteredDistance === 'allLocations') {
				window.localStorage.setItem('isLocationPopoverVisible', 'false');
			} else {
				this.setState({ isLocationPopoverVisible: true }, () => {
					window.localStorage.setItem('isLocationPopoverVisible', 'false');
				});
			}
		}
	}

	filterJobs = (property, match, jobSet = []) => {
		return jobSet.filter((job) => get(job, property) === match);
	};

	handleResize = () => {
		const containerWidth = this.containerRef.current
			? this.containerRef.current.offsetWidth
			: 0;
		if (containerWidth === 0 && this.resizeAttempts < 50) {
			this.resizeAttempts++;
			return;
		}

		if (containerWidth > 0 && this.intervalId) {
			clearInterval(this.intervalId);
		}

		if (this.state.onlyShowHot) {
			this.setState({ pageSizeHotJobs: 24 });
		} else if (
			containerWidth < 1310 &&
			containerWidth > 901 &&
			window.innerWidth > 1000
		) {
			// Don't ask me why this is where our breakpoint is, but it is
			this.setState({ pageSizeHotJobs: 3 });
		} else {
			this.setState({ pageSizeHotJobs: 4 });
		}
	};

	updateFilteredJobsByLocation = async (filteredDistance, newLocation) => {
		const { lat, lng, city, state, country, zip } = this.state;
		const location = newLocation || {
			lat,
			lng,
			city,
			state,
			country,
			zip,
		};
		const { searchQuery } = this.state;
		if (filteredDistance) {
			this.setState({ filteredDistance }, async () => {
				if (city && state && lat && lng && country) {
					const jobLocationCoordinate = location;
					window.localStorage.setItem(
						'jobLocationCoordinate',
						JSON.stringify(jobLocationCoordinate)
					);
					this.setState(
						{ ...jobLocationCoordinate },
						async () => await this.setQueryToState(searchQuery)
					);
				} else if (city && state) {
					// Include country so the filter anchor geocodes to the right country
					// (an international "Dublin" filter must resolve to Ireland, not Ohio).
					const jobLocationCoordinate = await getLocation({ city, state, country });
					window.localStorage.setItem(
						'jobLocationCoordinate',
						JSON.stringify(jobLocationCoordinate)
					);
					this.setState(
						{ ...jobLocationCoordinate },
						async () => await this.setQueryToState(searchQuery)
					);
				} else if (zip) {
					const jobLocationCoordinate = await getLocation({ zip });
					window.localStorage.setItem(
						'jobLocationCoordinate',
						JSON.stringify(jobLocationCoordinate)
					);
					this.setState(
						{ ...jobLocationCoordinate },
						async () => await this.setQueryToState(searchQuery)
					);
				} else if (lat && lng) {
					await this.setQueryToState(searchQuery);
				}
			});
		}
	};

	handleFilterDepartment = (department) => {
		let { filteredDepartments, searchQuery } = this.state;
		if (filteredDepartments.includes(department)) return;
		filteredDepartments = [...filteredDepartments, department];
		this.setState(
			{
				filteredDepartments,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleRemoveDepartmentFilter = (department) => {
		const { filteredDepartments, searchQuery = '' } = this.state;
		const index = filteredDepartments.indexOf(department);
		filteredDepartments.splice(index, 1);
		this.setState(
			{
				filteredDepartments,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterOpenStatus = (newStatus) => {
		// Support both usage patterns: with parameter (from toggle) or without (legacy)
		const filterOpenStatus =
			newStatus || (this.state.filterOpenStatus === 'open' ? 'closed' : 'open');
		this.setState(
			{
				filterOpenStatus,
				text: filterOpenStatus === 'open' ? 'Open Jobs' : 'Closed Jobs',
			},
			async () => await this.setQueryToState(this.state.searchQuery)
		);
	};

	handleFilterAvailable = (option) => {
		const { searchQuery } = this.state;
		this.setState(
			{
				filteredAvailables: [option],
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleRemoveAvailableFilter = (option) => {
		const { filteredAvailables, searchQuery } = this.state;
		const index = filteredAvailables.indexOf(option);
		filteredAvailables.splice(index, 1);
		this.setState(
			{
				filteredAvailables,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterCompany = (company, key) => {
		let { filteredCompanies = [], searchQuery = '' } = this.state;
		if (filteredCompanies.includes(company)) return;
		filteredCompanies = [...filteredCompanies, company];
		this.setState(
			{
				filteredCompanies,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleRemoveCompanyFilter = (company) => {
		const { filteredCompanies = [], searchQuery } = this.state;
		const index = filteredCompanies
			.map((company) => company.name)
			.indexOf(company);
		filteredCompanies.splice(index, 1);
		this.setState(
			{
				filteredCompanies,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterSalary = (filteredSalary) => {
		const { searchQuery = '' } = this.state;
		this.setState(
			{
				filteredSalary,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterCompensationGrade = (values) => {
		const { searchQuery = '' } = this.state;
		this.setState(
			{
				filteredCompensationGrades: values,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterHiringManager = (values) => {
		const { searchQuery = '' } = this.state;
		this.setState(
			{
				filteredHiringManagers: values,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	fetchCompensationGrades = async () => {
		const companyId = this.props?.currentUser?.companyId;
		if (!companyId || !this.props.client) return;

		try {
			const { data } = await this.props.client.query({
				query: QueryCompensationGradesByCompanyId,
				variables: { companyId },
				fetchPolicy: 'cache-first',
			});
			const grades = (data?.queryCompensationGradesByCompanyId || [])
				.map((g) => g.compensationGrade)
				.filter(Boolean)
				.sort();
			this.setState({ compensationGradeOptions: grades });
		} catch {
			// Silently fail — filter will just have no options
		}
	};

	fetchHiringManagers = async () => {
		const companyId = this.props?.currentUser?.companyId;
		if (!companyId || !this.props.client) return;

		try {
			const { data } = await this.props.client.query({
				query: QueryHiringManagersByCompanyId,
				variables: { companyId },
				fetchPolicy: 'cache-first',
			});
			const managers = data?.queryHiringManagersByCompanyId || [];
			const options = managers
				.map((m) => ({
					employeeId: m.employeeId,
					name: `${m.firstName || ''} ${m.lastName || ''}`.trim(),
				}))
				.filter((m) => m.name)
				.sort((a, b) => a.name.localeCompare(b.name));
			this.setState({ hiringManagerOptions: options });
		} catch {
			// Silently fail — filter will just have no options
		}
	};

	handleFilterDate = (filteredDate) => {
		const { searchQuery = '' } = this.state;
		this.setState(
			{
				filteredDate,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterBonus = (bonus) => {
		let { filteredBonuses = [], searchQuery = '' } = this.state;
		if (filteredBonuses.includes(bonus)) return;
		filteredBonuses = [...filteredBonuses, bonus];
		this.setState(
			{
				filteredBonuses,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleRemoveBonusFilter = (bonus) => {
		const { filteredBonuses = [], searchQuery = '' } = this.state;
		const index = filteredBonuses.indexOf(bonus);
		filteredBonuses.splice(index, 1);
		this.setState(
			{
				filteredBonuses,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterSubCompany = (subCompany, a) => {
		let { filteredSubCompanies = [], searchQuery = '' } = this.state;
		if (filteredSubCompanies.includes(subCompany)) return;
		filteredSubCompanies = [...filteredSubCompanies, subCompany];
		this.setState(
			{
				filteredSubCompanies,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleRemoveSubCompanyFilter = (subCompany) => {
		const { filteredSubCompanies = [], searchQuery = '' } = this.state;
		const index = filteredSubCompanies.indexOf(subCompany);
		filteredSubCompanies.splice(index, 1);
		this.setState(
			{
				filteredSubCompanies,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleFilterJobLevel = (jobLevel, data) => {
		let { filteredJobLevels = [], searchQuery = '' } = this.state;
		const jobLvl = get(data, 'props.jobLevel');
		if (filteredJobLevels.map((b) => b.id).includes(jobLevel)) return;
		filteredJobLevels = [...filteredJobLevels, jobLvl];
		this.setState(
			{
				filteredJobLevels,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	handleRemoveJobLevelFilter = (jobLevel) => {
		const { filteredJobLevels = [], searchQuery = '' } = this.state;
		const index = filteredJobLevels.map((b) => b.id).indexOf(jobLevel);
		filteredJobLevels.splice(index, 1);
		this.setState(
			{
				filteredJobLevels,
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	hideModal = () => {
		this.setState({ isLocationPopoverVisible: false });
	};

	handleFilterLocation = (distance) => {
		window.localStorage.setItem(
			'setWithInDistance',
			this.makeOldMenuOption(distance)
		);
		if (distance === 'allLocations') {
			this.handleRemoveLocationFilter();
		} else {
			this.updateFilteredJobsByLocation(this.makeNewMenuOption(distance));
		}
	};

	handleRemoveLocationFilter = () => {
		const { searchQuery } = this.state;
		this.setState(
			{
				filteredDistance: 'allLocations',
			},
			async () => await this.setQueryToState(searchQuery)
		);
	};

	makeNewMenuOption = () => {
		let distance = window.localStorage.getItem('setWithInDistance');
		if (distance === null) {
			distance =
				this.props.currentUser?.defaultDistance || null
					? this.props.currentUser.defaultDistance
					: this.props.currentUser?.company?.defaultLocation || null
						? this.props.currentUser.company.defaultLocation
						: 'allLocations';
		}

		if (distance === 'allLocations' || distance == '0') {
			return 'allLocations';
		}

		if (isNaN(distance / 1)) {
			return 'myCountry';
		}

		if (distance == '-1') {
			return 'remote';
		}

		if (distance == '25') {
			return 'within25';
		}

		if (distance == '50') {
			return 'within50';
		}

		if (distance == '100') {
			return 'within100';
		}

		if (distance == '200') {
			return 'within200';
		}
	};

	makeOldMenuOption = (value) => {
		if (value === 'myCountry') {
			return this.state?.country || 'US';
		}

		if (value === 'remote') {
			return '-1';
		}

		if (value === 'within25') {
			return '25';
		}

		if (value === 'within50') {
			return '50';
		}

		if (value === 'within100') {
			return '100';
		}

		if (value === 'within200') {
			return '200';
		}

		return '0';
	};

	renderArrowIcon = () => {
		return (
			<div>
				<WebIcon color="var(--oslo-gray)" size={10} name="sort-down" />
			</div>
		);
	};

	renderFilters = () => {
		const {
			isExtendedUser,
			searchQuery,
			address,
			filteredBonuses,
			filteredDepartments,
			filteredSubCompanies,
			filteredSalary,
			filteredDate,
			activeBonusRange,
			filteredDistance,
			visibleAdvance,
			filterTitle,
			isLocationPopoverVisible,
			filteredJobLevels,
			filteredAvailables,
			bonusRange,
			someJobHasBonus,
			hideBonusFilter,
			hideSubcompanyOnJobs,
			subCompanyLabel,
			currencySymbol,
			iconContainer,
		} = this.state;
		const {
			jobLevels = [],
			subCompanies = [],
			departments = [],
			bonuses = [],
			currentUser,
			allMultiLingualData,
			availableOptions = [],
		} = this.props;
		const enableGeneralReferrals = get(
			currentUser,
			'company.enableGeneralReferrals',
			true
		);

		const extendedCompaniesData = get(
			this.props,
			'currentUser.extendedCompaniesData',
			[]
		);
		const extendedCompanies = extendedCompaniesData.filter(
			(company) => get(company, 'disableExtendedUserJobsView') !== true
		);
		const companies =
			extendedCompanies &&
			get(this.props, 'currentUser.role') === 'extendedUser'
				? extendedCompanies
				: [get(this.props, 'currentUser.company')];

		const comps = _.sortBy(companies, ['name']);
		const companyOptions = comps.map((company) => {
			return (
				<Option key={get(company, 'id')} value={get(company, 'id')}>
					{get(company, 'name')}
				</Option>
			);
		});

		const jobFilterSettings = this.props.currentUser?.company?.jobFilterSettings
			? JSON.parse(this.props.currentUser.company.jobFilterSettings)
			: {};

		return (
			<>
				<div>
					<AdvanceFilters
						noBonusValue={this.state.noBonusValue}
						companyOptions={companyOptions}
						iconContainer={iconContainer}
						currentUser={currentUser}
						companyData={this.state.companyData}
						bonuses={bonuses || []}
						departments={departments || []}
						subCompanies={subCompanies || []}
						jobLevels={jobLevels || []}
						availableOptions={availableOptions || []}
						filteredDate={filteredDate}
						filteredCompanies={this.state.filteredCompanies}
						filteredDepartments={filteredDepartments}
						filteredSubCompanies={filteredSubCompanies}
						filteredJobLevels={filteredJobLevels}
						filteredAvailables={filteredAvailables}
						filteredBonuses={filteredBonuses}
						filteredSalary={filteredSalary}
						activeBonusRange={activeBonusRange}
						isExtendedUser={isExtendedUser}
						bonusRange={bonusRange}
						someJobHasBonus={someJobHasBonus}
						hideBonusFilter={hideBonusFilter}
						hideSubcompanyOnJobs={hideSubcompanyOnJobs}
						subCompanyLabel={subCompanyLabel}
						currencySymbol={currencySymbol}
						handleFilterCompany={this.handleFilterCompany}
						handleRemoveCompanyFilter={this.handleRemoveCompanyFilter}
						handleFilterDate={this.handleFilterDate}
						handleFilterDepartment={this.handleFilterDepartment}
						handleRemoveDepartmentFilter={this.handleRemoveDepartmentFilter}
						handleFilterSubCompany={this.handleFilterSubCompany}
						handleRemoveSubCompanyFilter={this.handleRemoveSubCompanyFilter}
						handleFilterJobLevel={this.handleFilterJobLevel}
						handleRemoveJobLevelFilter={this.handleRemoveJobLevelFilter}
						handleFilterAvailable={this.handleFilterAvailable}
						handleRemoveAvailableFilter={this.handleRemoveAvailableFilter}
						handleFilterBonus={this.handleFilterBonus}
						handleRemoveBonusFilter={this.handleRemoveBonusFilter}
						handleFilterSalary={this.handleFilterSalary}
						handleBonusRangeChange={this.handleBonusRangeChange}
						renderBonusRangeSlider={this.renderBonusRangeSlider}
						resetBonusRange={this.resetBonusRange}
						filterOpenStatus={this.state.filterOpenStatus}
						handleFilterOpenStatus={this.handleFilterOpenStatus}
						openStatusText={this.state.text}
						visibleAdvance={visibleAdvance}
						filterTitle={filterTitle}
						handleToggleFilters={this.handleToggleFilters}
						filteredDistance={filteredDistance}
						address={address}
						isLocationPopoverVisible={isLocationPopoverVisible}
						handleLocationFilter={this.handleLocationFilter}
						handleSetLocation={this.handleSetLocation}
						renderLocationFilter={this.renderLocationFilter}
						allMultiLingualData={allMultiLingualData}
						searchQuery={searchQuery}
						setQueryToState={this.setQueryToState}
						displaySearchFilter={this.displaySearchFilter}
						loading={this.state.loading}
						enableGeneralReferrals={enableGeneralReferrals}
						showModalGeneral={this.showModalGeneral}
						jobFilterSettings={jobFilterSettings}
						filteredCompensationGrades={this.state.filteredCompensationGrades}
						filteredHiringManagers={this.state.filteredHiringManagers}
						compensationGradeOptions={this.state.compensationGradeOptions}
						hiringManagerOptions={this.state.hiringManagerOptions}
						handleFilterCompensationGrade={this.handleFilterCompensationGrade}
						handleFilterHiringManager={this.handleFilterHiringManager}
					/>
				</div>
			</>
		);
	};

	setFilterTitle = () => {
		this.setState({
			filterTitle:
				this.state.filterTitle === 'Show Filters'
					? 'Hide Filters'
					: 'Show Filters',
			visibleAdvance: this.state.filterTitle === 'Show Filters',
		});
	};

	handleToggleFilters = () => {
		this.setFilterTitle();
	};

	handleSetLocation = () => {
		this.showModal();
	};

	handleLocationFilter = (distance) => {
		this.handleFilterLocation(distance);
	};

	handleSearchChange = (value) => {
		this.setState({ searchQuery: value });
	};

	handleSearch = (searchQuery) => {
		this.setQueryToState(searchQuery);
	};

	renderLocationFilter = () => {
		// This method can return location filter options if needed
		return null;
	};

	setSearch = (searchedJobs = []) => {
		let { allJobs = [] } = this.state;
		if (searchedJobs) {
			allJobs =
				searchedJobs.length > allJobs.length
					? [...searchedJobs, ...allJobs]
					: allJobs;
			this.setState({ searchedJobs, loading: false });
		}
	};

	setQueryToState = async (
		searchQuery = '',
		searchParameters = null,
		overrideState = null,
		searchedJobsPagination = null,
		searchedHotJobsPagination = null
	) => {
		const { updateCurrentUserSearchCriteria, currentUser, setCurrentUser } =
			this.props;
		const state = overrideState ? overrideState : this.state;
		let {
			filteredDistance = 'allLocations',
			filterOpenStatus = 'open',
			lat = null,
			lng = null,
			filteredAvailables = [],
			filteredBonuses = [],
			filteredCompanies = [],
			filteredDate = 0,
			filteredDepartments = [],
			filteredJobLevels = [],
			filteredSalary = undefined,
			filteredSubCompanies = [],
			filteredCompensationGrades = [],
			filteredHiringManagers = [],
		} = state;
		const [from, to] = getISODateRangeUTC([
			subtractDays(filteredDate),
			new Date().toISOString(),
		]);
		const dateParameter = filteredDate
			? {
					dateCreated: {
						from,
						to,
					},
				}
			: {};
		const filterCompanies = state?.filteredCompanies || [];
		const extendedCompaniesData =
			this.props?.currentUser?.extendedCompaniesData || [];
		const extendedCompanies = extendedCompaniesData.filter(
			(company) => company?.disableExtendedUserJobsView !== true
		);
		const isExtendedUser = this.props?.currentUser?.role === 'extendedUser';
		const comps =
			extendedCompanies &&
			extendedCompanies.length > 0 &&
			isExtendedUser &&
			extendedCompanies[0] !== null
				? extendedCompanies
				: [this.props?.currentUser?.company];
		const companies = comps.map((company) => get(company, 'id'));
		filteredCompanies =
			filterCompanies.length > 0 ? filterCompanies : companies;
		const unit =
			this.props?.currentUser?.userGroup?.measurement === 'metric'
				? 'km'
				: 'mi';
		clearTimeout(this.timer);
		this.setState({ searchQuery });
		updateCurrentUserSearchCriteria(searchQuery);
		this.timer = setTimeout(async () => {
			this.setState({ loading: true });
			let from = 0;
			let size = 300;
			if (searchedJobsPagination) {
				from = searchedJobsPagination?.next?.from;
				size = searchedJobsPagination?.next?.size;
				if (from + size > 9999) size = 9999 - from;
			}

			let parameters = {
				query: searchQuery,
				from,
				size,
				coordinates: [{ lat, lng }],
				role: this.props?.currentUser?.role,
				currentUser: this.props?.currentUser?.id,
				filters: {
					availables: filteredAvailables,
					bonuses: filteredBonuses,
					companies: filteredCompanies,
					departments: filteredDepartments,
					distance: this.makeOldMenuOption(filteredDistance),
					salary: filteredSalary,
					status: filterOpenStatus,
					subCompanies: filteredSubCompanies,
					jobLevels: filteredJobLevels,
					isHotJob: false,
					...(filteredDate && dateParameter),
					...(filteredCompensationGrades.length > 0 && {
						compensationGrades: filteredCompensationGrades,
					}),
					...(filteredHiringManagers.length > 0 && {
						hiringManagerEmployeeIds: filteredHiringManagers,
					}),
				},
				unit,
			};
			if (searchParameters) parameters = searchParameters;
			let response = null;
			if (from + size < 10_000)
				response = await searchOpenSearchNetwork(parameters, 'erin-jobs');

			parameters.filters.isHotJob = true;
			if (searchedHotJobsPagination) {
				from = searchedHotJobsPagination?.next?.from;
				size = searchedHotJobsPagination?.next?.size;
				if (from + size > 9999) size = 9999 - from;
				parameters.size = size;
				parameters.from = from;
			} else {
				from = 0;
				size = 300;
				parameters.size = size;
				parameters.from = from;
			}

			let hotJobResponse = null;
			if (from + size < 10_000)
				hotJobResponse = await searchOpenSearchNetwork(parameters, 'erin-jobs');

			if (response?.search) {
				currentUser.search = response.search;
				setCurrentUser(currentUser);
			}

			if (
				get(response, 'query') === get(this.state, 'searchQuery') ||
				get(hotJobResponse, 'query') === get(this.state, 'searchQuery')
			) {
				let searchedJobs = searchedJobsPagination
					? [...this.state.searchedJobs, ...get(response, 'data', [])]
					: get(response, 'data', []);
				const page = response?.metadata?.page;
				const totalResults = get(response, 'metadata.showing.totalItems', 0);
				const totalHotJobResults = get(
					hotJobResponse,
					'metadata.showing.totalItems',
					0
				);
				const filterOn =
					filteredDistance !== 'allLocations' || searchQuery.length > 0;

				searchedJobs = filterOn
					? searchedJobs || []
					: _.orderBy(
							searchedJobs || [],
							['isHotJob', 'dateCreated'],
							['desc', 'desc']
						);

				const searchedHotJobs = searchedHotJobsPagination
					? [...this.state.searchedHotJobs, ...get(hotJobResponse, 'data', [])]
					: get(hotJobResponse, 'data', []);
				const hotJobPage = hotJobResponse?.metadata?.page;
				const input = {
					loading: false,
				};
				if (searchedJobs) input.searchedJobs = searchedJobs;
				if (page) input.searchedJobsPagination = page;
				if (searchedHotJobs) input.searchedHotJobs = searchedHotJobs;
				if (hotJobPage) input.searchedHotJobsPagination = hotJobPage;
				if (totalResults) input.totalResults = totalResults;
				if (totalHotJobResults) input.totalHotJobResults = totalHotJobResults;
				if (!searchedJobsPagination) input.currentJobsPage = 1;
				if (!searchedHotJobsPagination) input.currentHotJobsPage = 1;
				searchedHotJobsPagination = null;

				this.setState(input);
			} else {
				this.setState({ loading: false });
			}
		}, 700);
	};

	loadMoreResults = async () => {
		const {
			searchedJobs = [],
			searchedJobsPagination,
			searchedHotJobsPagination = null,
			searchQuery = '',
		} = this.state;
		if (searchedJobs.length < 10_000)
			await this.setQueryToState(
				searchQuery,
				null,
				null,
				searchedJobsPagination,
				searchedHotJobsPagination
			);
	};

	loadMoreHotJobsResults = async () => {
		const {
			searchedHotJobs = [],
			searchedJobsPagination,
			searchedHotJobsPagination,
			searchQuery = '',
		} = this.state;
		if (searchedHotJobs.length < 10_000)
			await this.setQueryToState(
				searchQuery,
				null,
				null,
				searchedJobsPagination,
				searchedHotJobsPagination
			);
	};

	setJobsGeneralQueryToState = async () => {
		const { lat, lng } = this.state;
		const filterCompanies = get(this.state, 'filteredCompanies', []);
		const extendedCompaniesData = get(
			this.props,
			'currentUser.extendedCompaniesData',
			[]
		);
		const extendedCompanies = extendedCompaniesData.filter(
			(company) => get(company, 'disableExtendedUserJobsView') !== true
		);
		const isExtendedUser =
			get(this.props, 'currentUser.role') === 'extendedUser';
		const comps =
			extendedCompanies && extendedCompanies.length > 0 && isExtendedUser
				? extendedCompanies
				: [get(this.props, 'currentUser.company')];
		const companies = comps.map((company) => get(company, 'id'));
		const filteredCompanies =
			filterCompanies.length > 0 ? filterCompanies : companies;

		const unit =
			get(this.props, 'currentUser.userGroup.measurement', 'imperial') ===
			'metric'
				? 'km'
				: 'mi';
		this.timerGeneralJobs = setTimeout(async () => {
			const parameters = {
				query: '',
				size: 300,
				coordinates: [{ lat, lng }],
				role: get(this.props, 'currentUser.role'),
				currentUser: get(this.props, 'currentUser.id'),
				filters: {
					companies: filteredCompanies,
					status: 'open',
					isGeneralReferral: true,
				},
				unit,
			};
			const response = await searchOpenSearchNetwork(parameters, 'erin-jobs');
			if (get(response, 'query') === '') {
				const searchedJobs = get(response, 'data', []);
				if (searchedJobs) {
					const filteredJobsGeneral = searchedJobs;
					this.setState({
						filteredJobsGeneral,
					});
				}
			}
		}, 700);
	};

	async getCurrencyRate(currency) {
		const response = await fetch(
			`https://api.exchangeratesapi.io/latest?base=USD&symbols=${currency}`
		);
		const result = await response.json();
		if (result.error) {
			// Make this USD
			this.setState({
				currencyRate: 1,
				currencySymbol: '$',
			});
		} else {
			const rate = result.rates[currency].toFixed(5);
			const symbol = getSymbolFromCurrency(currency)
				? getSymbolFromCurrency(currency)
				: '$';
			this.props.setCurrentCurrencyRate(rate);
			this.props.setCurrentCurrencySymbol(symbol);
			this.setState({
				currencyRate: rate,
				currencySymbol: symbol,
			});
		}
	}

	showModal = () => {
		this.setState({ visible: true });
	};

	showModalGeneral = () => {
		this.setState({ visibleGeneral: true });
	};

	handleCancelGeneral = () => {
		this.setState({ visibleGeneral: false });
	};

	handleSubmit = async (jobLocationCoordinate) => {
		try {
			if (
				get(jobLocationCoordinate, 'zip') &&
				!get(jobLocationCoordinate, 'lat') &&
				!get(jobLocationCoordinate, 'lng')
			)
				jobLocationCoordinate = await getLocation({
					zip: jobLocationCoordinate.zip,
				});

			window.localStorage.setItem(
				'jobLocationCoordinate',
				JSON.stringify(jobLocationCoordinate)
			);
			this.setState(
				{
					...jobLocationCoordinate,
					success: true,
				},
				() => this.handleFilterLocation(this.state.filteredDistance)
			);
		} catch (error) {
			console.log(error);
		}
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	ShowAllToggle = () => {
		const { onlyShowHot } = this.state;
		if (onlyShowHot) {
			this.setState({ onlyShowHot: !onlyShowHot }, () => {
				this.handleResize();
			});
		} else {
			this.setState({ onlyShowHot: !onlyShowHot, pageSizeHotJobs: 24 });
		}
	};

	setUpdatedContacts = (newContact) => {
		this.setState((prevState) => ({
			updatedContacts: [...prevState.updatedContacts, newContact],
		}));
	};

	renderBonusRangeSlider = () => {
		const { activeBonusRange } = this.state;
		const { bonuses = [], currentUser } = this.props;

		const bonusTierAmounts = bonuses
			.map((bonus) => {
				const total = bonus.tiers
					.map((tierJSON) => JSON.parse(tierJSON))
					.filter((tier) => tier.recipientType === 'employee')
					.filter((tier) => tier.userGroup === currentUser.userGroupId)
					.reduce((sum, tier) => sum + Number.parseInt(tier.amount), 0);
				return { id: bonus.id, total };
			})
			.sort((a, b) => a.total - b.total);

		const tierAmounts = bonusTierAmounts.map((item) => item.total);

		const min =
			tierAmounts.length > 0 ? Math.max(0, Math.min(...tierAmounts)) : 0;
		const max =
			tierAmounts.length > 0 ? Math.max(0, Math.max(...tierAmounts)) : 0;

		const value =
			activeBonusRange &&
			Array.isArray(activeBonusRange) &&
			(activeBonusRange[0] !== 0 || activeBonusRange[1] !== 0)
				? activeBonusRange
				: [min, max];
		const userCurrencySymbol = currentUser?.userGroup?.currency
			? getSymbolFromCurrency(currentUser.userGroup.currency)
			: currentUser?.currency
				? getSymbolFromCurrency(currentUser.currency)
				: '$';

		const marks = {
			[min]: {
				style: { left: '3%', userSelect: 'none' },
				label: `${userCurrencySymbol}${min.toLocaleString()}`,
			},
			[max]: {
				style: { left: '93%', userSelect: 'none' },
				label: `${userCurrencySymbol}${max.toLocaleString()}`,
			},
		};
		if (max > 0) {
			return (
				<Slider
					range
					min={min}
					max={max}
					value={value}
					onChange={this.handleBonusRangeChange}
					onAfterChange={this.applyBonusRangeFilter}
					marks={marks}
					tooltip={{
						formatter: (value) =>
							`${userCurrencySymbol}${value.toLocaleString()}`,
						placement: 'bottom',
					}}
					trackStyle={{ backgroundColor: 'oklch(0.7099 0.1414 141.23)' }}
					style={{
						display: 'inline-flex',
						width: '120px',
						verticalAlign: 'middle',
						userSelect: 'none',
					}}
				/>
			);
		} else {
			return (
				<Slider
					disabled
					range
					min={1}
					max={1000}
					value={1}
					tooltip={{ formatter: null }}
					handleStyle={{ filter: 'grayscale(1)' }}
					style={{
						display: 'inline-flex',
						width: '120px',
						verticalAlign: 'middle',
						userSelect: 'none',
					}}
				/>
			);
		}
	};

	extractBonusAmounts = (bonuses) => {
		if (!bonuses || !Array.isArray(bonuses)) {
			this.setState({
				bonusAmounts: [],
				bonusRange: [0, 10000],
				activeBonusRange: [0, 10000],
			});
			return;
		}

		const amounts = bonuses
			.map((b) => b?.amount)
			.filter((amount) => amount && amount > 0);

		const uniqueAmounts = [...new Set(amounts)].sort((a, b) => a - b);

		if (uniqueAmounts.length > 0) {
			this.setState({
				bonusAmounts: uniqueAmounts,
				bonusRange: [
					uniqueAmounts?.[0],
					uniqueAmounts[uniqueAmounts.length - 1],
				],
				activeBonusRange: [
					uniqueAmounts?.[0],
					uniqueAmounts[uniqueAmounts.length - 1],
				],
			});
		} else {
			this.setState({
				bonusAmounts: [],
				bonusRange: [0, 10000],
				activeBonusRange: [0, 10000],
			});
		}
	};

	handleBonusRangeChange = (value) => {
		this.setState({ activeBonusRange: value });
	};

	resetBonusRange = () => {
		this.setState({ activeBonusRange: undefined }, () => {
			this.setQueryToState(this.state.searchQuery);
		});
	};

	applyBonusRangeFilter = () => {
		const { activeBonusRange } = this.state;
		const { bonuses = [], currentUser } = this.props;

		if (!bonuses || !Array.isArray(bonuses) || bonuses.length === 0) {
			this.setState(
				{
					filteredBonuses: [],
				},
				() => {
					this.setQueryToState(this.state.searchQuery);
				}
			);
			return;
		}

		const bonusTierAmounts = bonuses
			.filter((bonus) => bonus && bonus.tiers && Array.isArray(bonus.tiers))
			.map((bonus) => {
				try {
					const total = bonus.tiers
						.map((tierJSON) => {
							try {
								return JSON.parse(tierJSON);
							} catch {
								return null;
							}
						})
						.filter((tier) => tier && tier.recipientType === 'employee')
						.filter((tier) => tier.userGroup === currentUser?.userGroupId)
						.reduce(
							(sum, tier) => sum + (Number.parseInt(tier.amount) || 0),
							0
						);
					return { id: bonus.id, total };
				} catch {
					return { id: bonus.id, total: 0 };
				}
			});

		const tierAmounts = bonusTierAmounts
			.map((b) => b.total)
			.filter((amount) => amount > 0);
		const defaultMin =
			tierAmounts.length > 0 ? Math.max(0, Math.min(...tierAmounts)) : 0;
		const defaultMax =
			tierAmounts.length > 0 ? Math.max(0, Math.max(...tierAmounts)) : 0;

		const isDefaultRange =
			activeBonusRange &&
			activeBonusRange[0] === defaultMin &&
			activeBonusRange[1] === defaultMax;

		if (isDefaultRange) {
			this.setState(
				{
					filteredBonuses: [],
				},
				() => {
					this.setQueryToState(this.state.searchQuery);
				}
			);
			return;
		}

		const filteredBonusIds = bonusTierAmounts
			.filter(
				(bonus) =>
					activeBonusRange &&
					Array.isArray(activeBonusRange) &&
					bonus.total >= activeBonusRange[0] &&
					bonus.total <= activeBonusRange[1]
			)
			.map((b) => b.id);

		// This dummy string will force open search to return nothing when no bonuses are matching. - Baker (not ai)
		const finalFilteredBonuses =
			filteredBonusIds.length === 0
				? ['no-bonuses-match-criteria']
				: filteredBonusIds;

		this.setState(
			{
				filteredBonuses: finalFilteredBonuses,
			},
			() => {
				this.setQueryToState(this.state.searchQuery);
			}
		);
	};

	render() {
		const {
			allMultiLingualData,
			currentUser,
			companyData,
			onUpdateJob,
			contacts,
			location,
			onCreateReferral,
			onCreateUserJobShare,
			userJobShares,
			onUpdateUserJobShare,
		} = this.props;
		const {
			success,
			visible,
			filteredDistance,
			company,
			currencyRate,
			currencySymbol,
			currentJobsPage = 1,
			currentHotJobsPage = 1,
			extendedNetworkUsers,
			filterOpenStatus,
			searchedHotJobs,
			isExtendedUser,
			loading,
			searchedJobs,
			contactsNextToken,
			visibleGeneral,
			contact,
			onDeckContacts,
			filteredJobsGeneral,
			onlyShowHot,
			hideSubcompanyOnJobs,
			errorImageURL,
			pageSizeHotJobs,
			totalResults,
			totalHotJobResults,
		} = this.state;
		const contactIncentiveBonus = get(
			this.props,
			'currentUser.company.contactIncentiveBonus'
		);
		const allowSelfReferrals = get(
			this.props,
			'currentUser.company.allowSelfReferrals'
		);
		const allowSelfReferralsInternalLink = get(
			this.props,
			'currentUser.company.allowSelfReferralsInternalLink'
		);
		const whiteLabel = get(company, 'whiteLabel');
		if (
			(!searchedJobs || searchedJobs.length === 0) &&
			!loading &&
			window.location.pathname === '/browsejobs/new'
		)
			window.location.href = '/browsejobs';
		return get(currentUser, 'company') ? (
			<main>
				<div
					className="page-top-filter"
					style={{
						position: 'sticky',
						top: 0,
						zIndex: 100,
						background:
							'linear-gradient(in oklab to bottom, rgb(255 255 255 / 1), transparent)',
						backdropFilter: 'blur(8px)',
						// The gradient and blur span the full width beside the side nav so
						// they don't cut off at --content-max-width; the matching padding
						// puts the controls back on the capped grid.
						marginLeft: 'calc(-1 * var(--content-escape))',
						marginRight: 'calc(-1 * var(--content-escape))',
						padding: '12px var(--content-escape) 0',
						// Escape .content-area's 16px top padding, which otherwise shows as
						// a gray strip above the bar.
						marginTop: -16,
						marginBottom: 20,
						alignItems: 'flex-start',
						flexWrap: 'wrap',
					}}
				>
					{this.renderFilters()}

					{visibleGeneral && (
						<OnDeckReferralModal
							visible={visibleGeneral}
							currentUser={this.props.currentUser}
							contact={contact}
							contacts={contacts}
							handleCancel={this.handleCancelGeneral}
							referSomeoneText={ml(
								'Refer Someone',
								currentUser,
								allMultiLingualData
							)}
							doYouKnowText={ml(
								'Do you know someone who would thrive at',
								currentUser,
								allMultiLingualData
							)}
							submitThemText={ml(
								'Submit them to be considered for new opportunities.',
								currentUser,
								allMultiLingualData
							)}
							enterReferralText={ml(
								"Enter a referral and we'll send them information to apply.",
								currentUser,
								allMultiLingualData
							)}
							enterReferralInformationText={ml(
								'Enter Candidate Information',
								currentUser,
								allMultiLingualData
							)}
							firstNameText={ml('First Name', currentUser, allMultiLingualData)}
							lastNameText={ml('Last Name', currentUser, allMultiLingualData)}
							emailText={ml('Email Address', currentUser, allMultiLingualData)}
							textPlaceHolderText={ml('Text', currentUser, allMultiLingualData)}
							orText={ml('or', currentUser, allMultiLingualData)}
							clickHereText={ml('click here', currentUser, allMultiLingualData)}
							toAddExistingContactText={ml(
								'to add an existing contact',
								currentUser,
								allMultiLingualData
							)}
							includeMessageToContactText={ml(
								'Include a message to your contact',
								currentUser,
								allMultiLingualData
							)}
							optionalText={ml('optional', currentUser, allMultiLingualData)}
							personalizeMessageText={ml(
								'Personalize the message to your referral',
								currentUser,
								allMultiLingualData
							)}
							messageHiringContactText={ml(
								'Message the Hiring Contact',
								currentUser,
								allMultiLingualData
							)}
							howKnowThemText={ml(
								'How do you know them, why are they a good fit, etc.',
								currentUser,
								allMultiLingualData
							)}
							clickHereResumeText={ml(
								'Click here',
								currentUser,
								allMultiLingualData
							)}
							attachResumeText={ml(
								'to attach a resume',
								currentUser,
								allMultiLingualData
							)}
							submitReferralText={ml(
								'Submit Referral',
								currentUser,
								allMultiLingualData
							)}
							companyData={companyData}
							allMultiLingualData={allMultiLingualData}
							filteredJobs={filteredJobsGeneral}
							onDeckContacts={onDeckContacts}
							onUpdateJob={onUpdateJob}
							onCreateUserJobShare={onCreateUserJobShare}
							onUpdateUserJobShare={onUpdateUserJobShare}
						/>
					)}
				</div>

				{searchedHotJobs && searchedHotJobs.length > 0 ? (
					<>
						<div className="page-sub-title">
							<h4 className="sub-title">
								{ml('HOT JOBS', currentUser, allMultiLingualData)}
							</h4>
							<Button type="link" onClick={this.ShowAllToggle}>
								{searchedHotJobs.length >= 3 ? (
									onlyShowHot ? (
										<span style={{ color: COLORS.red }}>
											{ml('Collapse', currentUser, allMultiLingualData)}
										</span>
									) : (
										ml('Show All', currentUser, allMultiLingualData)
									)
								) : null}
							</Button>
						</div>
						<div ref={this.containerRef} style={{ marginBottom: '16px' }}>
							<List
								className="job-card-wrap"
								dataSource={searchedHotJobs}
								grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 4 }}
								pagination={
									searchedHotJobs.length > 3
										? {
												current: currentHotJobsPage,
												pageSize: pageSizeHotJobs,
												position: 'bottom',
												showSizeChanger: false,
												onChange: async (index, pageSize) => {
													if (
														index * pageSize >=
															searchedHotJobs.length - pageSize &&
														searchedHotJobs.length < totalHotJobResults
													)
														await this.loadMoreHotJobsResults();
													this.setState({ currentHotJobsPage: index });
												},
											}
										: false
								}
								renderItem={(job) => (
									<List.Item key={get(job, 'id')} style={{ height: '100%' }}>
										<JobCard
											key={get(job, 'id', 'skip')}
											allMultiLingualData={allMultiLingualData}
											excludeJob={this.excludeJob}
											isExtendedUser={isExtendedUser}
											extendedNetworkUsers={extendedNetworkUsers}
											navLocation={location}
											jobId={get(job, 'id', 'skip')}
											job={job}
											contactIncentiveBonus={contactIncentiveBonus}
											contacts={this.state.updatedContacts}
											setUpdatedContacts={this.setUpdatedContacts}
											contactsNextToken={contactsNextToken}
											currentUser={this.props.currentUser}
											allowSelfReferrals={allowSelfReferrals}
											currentCurrencyRate={currencyRate}
											currentCurrencySymbol={currencySymbol}
											currentUserCompany={companyData}
											referSomeoneText={ml(
												'Refer Someone',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											enterReferralText={ml(
												'We will send them information to apply.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											enterReferralInformationText={ml(
												'Enter Candidate Information',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											firstNameText={ml(
												'First Name',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											lastNameText={ml(
												'Last Name',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											emailText={ml(
												'Email Address',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											textPlaceHolderText={ml(
												'Text',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											orText={ml(
												'or',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											clickHereText={ml(
												'click here',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											toAddExistingContactText={ml(
												'to add an existing contact',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											includeMessageToContactText={ml(
												'Include a message to your contact',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											optionalText={ml(
												'optional',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											personalizeMessageText={ml(
												'Personalize the message to your referral',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											messageHiringContactText={ml(
												'Message the Recruiter',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											howKnowThemText={ml(
												'How do you know them, why are they a good fit, etc.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											clickHereResumeText={ml(
												'Click here',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											attachResumeText={ml(
												'to attach a resume',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											submitReferralText={ml(
												'Submit Referral',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											referContactText={ml(
												'Refer Contact',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											MakeReferralText={ml(
												'Make Referral',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											referralBonusText={ml(
												'Referral Bonus',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											referAContactText={ml(
												'Refer a Contact',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											startTypingText={ml(
												"Start typing a contact's name...",
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											importContactsText={ml(
												'import contacts',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											toEnterNameAndEmailText={ml(
												'to enter name and email',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											interestedText={ml(
												'Interested?',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											letUsKnowText={ml(
												'Let us know that you are interested in this position and we will be in touch.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											submitMeText={ml(
												'Submit Me For This Position',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											successText={ml(
												'Success. Your information has been submitted for this position.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											closeThisWindowText={ml(
												'Close This Window',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											iAmInterestedText={ml(
												"I'm Interested",
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											shareText={ml(
												'Share',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											shareJobText={ml(
												'Share Job',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											shareOnText={ml(
												'Share on',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											referralLinkText={ml(
												'Referral link',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											contactEmailText={ml(
												'A contact with this',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											alreadyReferredText={ml(
												'already exists.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											alreadyReferredReferralFormText={ml(
												'This person has already been referred for this position.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											clickHereReferralFormText={ml(
												'Click here',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											toReferReferralFormText={ml(
												'to refer them or',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											viewReferralFormText={ml(
												'view',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											contactReferralFormText={ml(
												'the contact.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											troubleReferralFormText={ml(
												'We are having trouble submitting the form. Please make sure the form is filled out correctly and try again.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											allowSelfReferralsInternalLink={
												allowSelfReferralsInternalLink
											}
											userJobShares={userJobShares}
											hideSubcompanyOnJobs={hideSubcompanyOnJobs}
											onUpdateJob={onUpdateJob}
											onCreateReferral={onCreateReferral}
											onCreateUserJobShare={onCreateUserJobShare}
											onUpdateUserJobShare={onUpdateUserJobShare}
										/>
									</List.Item>
								)}
							/>
							<h4
								className="sub-title"
								style={{
									fontWight: 600,
									fontSize: 14,
									textAlign: 'center',
									margin: 'auto',
									marginTop: 4,
								}}
							>
								{`${searchedHotJobs.length} ${ml('of', this.props.currentUser, this.props.allMultiLingualData)} ${totalHotJobResults} `}
								{totalHotJobResults === 0 || totalHotJobResults > 1
									? ml(
											'Hot Jobs',
											this.props.currentUser,
											this.props.allMultiLingualData
										)
									: ml(
											'Hot Job',
											this.props.currentUser,
											this.props.allMultiLingualData
										)}
								{totalHotJobResults > 10_000 && (
									<Tooltip
										arrowPointAtCenter
										placement="topRight"
										title={ml(
											'This search returns more than the limit of 10000 results. Please refine your search criteria in order to view all of the results.',
											this.props.currentUser,
											this.props.allMultiLingualData
										)}
										style={{ fontWeight: 1000 }}
									>
										<InfoCircleOutlined
											style={{
												padding: 5,
												cursor: 'pointer',
												color: '#1890ff',
											}}
										/>
									</Tooltip>
								)}
							</h4>
						</div>
					</>
				) : null}

				{onlyShowHot ? null : (
					<>
						{searchedJobs && searchedJobs.length > 0 ? (
							<>
								<div className="page-sub-title">
									{
										searchedHotJobs && searchedHotJobs.length > 0 ? (
											<h4 className="sub-title">
												{ml('ALL JOBS', currentUser, allMultiLingualData)}
											</h4>
										) : (
											<div />
										) // Helps keep jobs total on right when ALL JOBS isn't displayed
									}
								</div>
								<List
									className="job-card-wrap"
									grid={{
										gutter: 16,
										xs: 1,
										sm: 1,
										md: 2,
										lg: 2,
										xl: 3,
										xxl: 4,
									}}
									pagination={{
										current: currentJobsPage,
										pageSize: 24,
										showSizeChanger: false,
										onChange: async (index, pageSize) => {
											if (
												index * pageSize >= searchedJobs.length - pageSize &&
												searchedJobs.length < totalResults
											)
												await this.loadMoreResults();
											this.setState({ currentJobsPage: index });
										},
									}}
									dataSource={searchedJobs}
									renderItem={(job) => {
										const status = get(job, 'status', 'open');
										return status === filterOpenStatus && get(job, 'id') ? (
											<List.Item style={{ height: '100%' }}>
												<JobCard
													key={get(job, 'id', 'skip')}
													allMultiLingualData={allMultiLingualData}
													excludeJob={this.excludeJob}
													isExtendedUser={isExtendedUser}
													extendedNetworkUsers={extendedNetworkUsers}
													navLocation={location}
													jobId={get(job, 'id', 'skip')}
													job={job}
													contactIncentiveBonus={contactIncentiveBonus}
													contacts={this.state.updatedContacts}
													setUpdatedContacts={this.setUpdatedContacts}
													contactsNextToken={contactsNextToken}
													currentUser={this.props.currentUser}
													allowSelfReferrals={allowSelfReferrals}
													currentCurrencyRate={currencyRate}
													currentCurrencySymbol={currencySymbol}
													currentUserCompany={companyData}
													referSomeoneText={ml(
														'Refer Someone',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													enterReferralText={ml(
														'We will send them information to apply.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													enterReferralInformationText={ml(
														'Enter Candidate Information',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													firstNameText={ml(
														'First Name',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													lastNameText={ml(
														'Last Name',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													emailText={ml(
														'Email Address',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													textPlaceHolderText={ml(
														'Text',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													orText={ml(
														'or',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													clickHereText={ml(
														'click here',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													toAddExistingContactText={ml(
														'to add an existing contact',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													includeMessageToContactText={ml(
														'Include a message to your contact',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													optionalText={ml(
														'optional',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													personalizeMessageText={ml(
														'Personalize the message to your referral',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													messageHiringContactText={ml(
														'Message the Recruiter',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													howKnowThemText={ml(
														'How do you know them, why are they a good fit, etc.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													clickHereResumeText={ml(
														'Click here',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													attachResumeText={ml(
														'to attach a resume',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													submitReferralText={ml(
														'Submit Referral',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													referContactText={ml(
														'Refer Contact',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													MakeReferralText={ml(
														'Make Referral',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													referralBonusText={ml(
														'Referral Bonus',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													referAContactText={ml(
														'Refer a Contact',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													startTypingText={ml(
														"Start typing a contact's name...",
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													importContactsText={ml(
														'import contacts',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													toEnterNameAndEmailText={ml(
														'to enter name and email',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													interestedText={ml(
														'Interested?',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													letUsKnowText={ml(
														'Let us know that you are interested in this position and we will be in touch.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													submitMeText={ml(
														'Submit Me For This Position',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													successText={ml(
														'Success. Your information has been submitted for this position.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													closeThisWindowText={ml(
														'Close This Window',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													iAmInterestedText={ml(
														"I'm Interested",
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													shareText={ml(
														'Share',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													shareJobText={ml(
														'Share Job',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													shareOnText={ml(
														'Share on',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													referralLinkText={ml(
														'Referral link',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													contactEmailText={ml(
														'A contact with this',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													alreadyReferredText={ml(
														'already exists.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													alreadyReferredReferralFormText={ml(
														'This person has already been referred for this position.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													clickHereReferralFormText={ml(
														'Click here',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													toReferReferralFormText={ml(
														'to refer them or',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													viewReferralFormText={ml(
														'view',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													contactReferralFormText={ml(
														'the contact.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													troubleReferralFormText={ml(
														'We are having trouble submitting the form. Please make sure the form is filled out correctly and try again.',
														this.props.currentUser,
														this.props.allMultiLingualData
													)}
													allowSelfReferralsInternalLink={
														allowSelfReferralsInternalLink
													}
													userJobShares={userJobShares}
													hideSubcompanyOnJobs={hideSubcompanyOnJobs}
													onUpdateJob={onUpdateJob}
													onCreateReferral={onCreateReferral}
													onCreateUserJobShare={onCreateUserJobShare}
													onUpdateUserJobShare={onUpdateUserJobShare}
												/>
											</List.Item>
										) : (
											<div />
										);
									}}
								/>
								<h4
									className="sub-title"
									style={{
										fontWight: 600,
										fontSize: 14,
										textAlign: 'center',
										margin: 'auto',
										marginTop: 4,
									}}
								>
									{`${searchedJobs.length} ${ml('of', this.props.currentUser, this.props.allMultiLingualData)} ${totalResults}`}
									{totalResults === 0 || totalResults > 1
										? ' ' +
											ml(
												'Jobs',
												this.props.currentUser,
												this.props.allMultiLingualData
											)
										: ' ' +
											ml(
												'Job',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
									{totalResults > 10_000 && (
										<Tooltip
											arrowPointAtCenter
											placement="topRight"
											title={ml(
												'This search returns more than the limit of 10000 results. Please refine your search criteria in order to view all of the results.',
												this.props.currentUser,
												this.props.allMultiLingualData
											)}
											style={{ fontWeight: 1000 }}
										>
											<InfoCircleOutlined
												style={{
													padding: 5,
													cursor: 'pointer',
													color: '#1890ff',
												}}
											/>
										</Tooltip>
									)}
								</h4>
							</>
						) : (!searchedJobs || searchedJobs.length === 0) && !loading ? (
							<div className="no-content">
								{whiteLabel ? (
									<img
										src={errorImageURL}
										alt="error image"
										className="no-content-icon"
									/>
								) : (
									<img
										alt="erin-logo"
										className="no-content-icon"
										src={fileIcon}
									/>
								)}

								<p className="no-content-text">
									{ml(
										'No jobs found',
										this.props.currentUser,
										this.props.allMultiLingualData
									)}
								</p>
							</div>
						) : loading ? (
							<Spinner company={company} />
						) : (
							<div className="no-content">
								{whiteLabel ? (
									<img
										src={errorImageURL}
										alt="error image"
										className="no-content-icon"
									/>
								) : (
									<img
										alt="erin-logo"
										className="no-content-icon"
										src={fileIcon}
									/>
								)}
								<p className="no-content-text">
									{ml(
										'No jobs found',
										this.props.currentUser,
										this.props.allMultiLingualData
									)}
								</p>
							</div>
						)}
					</>
				)}
				<BrowseJobModal
					{...this.state}
					currentUser={currentUser}
					open={visible}
					handleCancel={this.handleCancel}
					handleSubmit={this.handleSubmit}
					success={success}
					filteredDistance={filteredDistance}
					updateFilteredJobsByLocation={this.updateFilteredJobsByLocation}
					changeLocationtext={ml(
						'Change Job Search Location',
						this.props.currentUser,
						this.props.allMultiLingualData
					)}
					autoFillText={ml(
						'Autofill Location',
						this.props.currentUser,
						this.props.allMultiLingualData
					)}
				/>
			</main>
		) : (
			<Spinner />
		);
	}
}

export default withApollo(BrowseJobsComponent);
